// Shared helpers for the admin statistics page date range.

export type DateRangePreset = "7d" | "30d" | "90d" | "12m" | "custom";

export interface DateRange {
  from: Date;
  to: Date;
  preset: DateRangePreset;
}

export function getPresetRange(preset: DateRangePreset): DateRange {
  const now = new Date();
  const to = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate() + 1, // exclusive upper bound = tomorrow
    ),
  );

  const from = new Date(to);
  switch (preset) {
    case "7d":
      from.setUTCDate(from.getUTCDate() - 7);
      break;
    case "30d":
      from.setUTCDate(from.getUTCDate() - 30);
      break;
    case "90d":
      from.setUTCDate(from.getUTCDate() - 90);
      break;
    case "12m":
      from.setUTCMonth(from.getUTCMonth() - 12);
      break;
    case "custom":
      from.setUTCDate(from.getUTCDate() - 30);
      break;
  }

  return { from, to, preset };
}

export function toIsoDate(d: Date): string {
  // ISO-8601 date (yyyy-MM-dd) — backend uses inclusive `from`, exclusive `to`.
  return d.toISOString().slice(0, 10);
}

export function formatRangeLabel(range: DateRange): string {
  const fmt = (d: Date) =>
    d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  // The `to` value is exclusive — show the inclusive last day for the user.
  const inclusiveTo = new Date(range.to);
  inclusiveTo.setUTCDate(inclusiveTo.getUTCDate() - 1);
  return `${fmt(range.from)} – ${fmt(inclusiveTo)}`;
}
